import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Rol } from './rol';
import {Observable} from 'rxjs/Rx';
import myGlobals = require('../config');

@Injectable()
export class RolService {

  private rolUrl = myGlobals.default.BASE_URL+'/rol/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todos los roles
  getRoles() {
    return this.http.get(this.rolUrl)
               .map((response) => response.json());
  }

  //Obtener un rol
  getRol(_id: string): Observable<Rol>  {
    return this.http.get(this.rolUrl+_id)
               .map((response) => response.json());
  }

  save(rol: Rol): Observable<Rol>  {
    if (rol._id) {
      return this.put(rol);
    }
    //Seteo estado activo
    rol.estado=true;
    return this.post(rol);
  }

  //Desactivar rol
  delete(rol: Rol) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.rolUrl}/${rol._id}`;

    return this.http
               .delete(url, {headers: headers})
               .map((response) => response.json());
  }

  // Agregar nuevo rol
  private post(rol: Rol):Observable<Rol> {
    let headers = new Headers({
      'Content-Type': 'application/json;charset=UTF-8'});
    headers.append('dataType', 'json');
    console.log(JSON.stringify(rol));
    var rolStr=JSON.stringify(rol);
    return this.http
               .post(this.rolUrl, rolStr, {headers: headers})
                .map((response) => response.json());
  }

  // Actualizar rol
  private put(rol: Rol) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.rolUrl}/${rol._id}`;

    return this.http
               .put(url, JSON.stringify(rol), {headers: headers})
               .map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/rol/rol.service.ts